$(function() {
    $('.js-tabs-ab').tabs({
        tabActive: 'discover__link--active action-button--active',
    });
});


// WEBPACK FOOTER //
// ./styleguide/src/assets/abtests/ab795.js